export default "__VITE_ASSET__ed9170d9__"